import { Pipe, PipeTransform } from '@angular/core';
import { SpedCollectionStudentToTeamMember } from '../../../../student-document-home/sped-student-document-cards/sped-student-document-cards.model';

@Pipe({
  name: 'isFormCreator'
})
export class IsFormCreatorPipe implements PipeTransform {

  transform(text: string, teamMembers: SpedCollectionStudentToTeamMember[]): boolean {
    if (text != 'FormName' && teamMembers.find(x => x.TeamMemberId == parseInt(text, 10)) != undefined) {
        const creator = teamMembers.find(x => x.TeamMemberId == parseInt(text, 10)).IsCreator;
        return creator;
    }
  }
}